export default __webpack_public_path__ + "static/media/qr.902a036e.svg";